import { qsa, qs, on, trimFields } from '../lib/dom.js';
import { t } from '../lib/i18n.js';

export function initContactForms() {
  const toast = qs('[data-role="toast"]');
  const toastMsg = qs('[data-role="toast-message"]');

  function showToast(msg, type = 'success') {
    if (!toast) return;
    if (toastMsg && msg) toastMsg.textContent = msg;
    toast.classList.toggle('ap-toast--error', type === 'error');
    toast.classList.add('is-visible');
    setTimeout(() => toast.classList.remove('is-visible'), 3500);
  }

  qsa('[data-component="contact-form"]').forEach((form) => {
    const btn = qs('button[type="submit"]', form);

    on(form, 'submit', async (e) => {
      e.preventDefault();
      // Whitespace is not a value: a lone Space satisfies `required`, so trim
      // before validating (and before the FormData below picks the values up).
      trimFields(form);
      let valid = true;

      // Validate each named field
      qsa('input, textarea, select', form).forEach((field) => {
        const wrap = field.closest('.ap-field, .ap-form__consent');
        const error = qs(`[data-error-for="${field.name}"]`, form);
        const ok = field.checkValidity();
        if (!ok) {
          valid = false;
          field.classList.add('is-error');
          if (wrap) wrap.classList.add('is-error');
        } else {
          field.classList.remove('is-error');
          if (wrap) wrap.classList.remove('is-error');
        }
      });

      if (!valid) {
        const firstInvalid = qs('.is-error', form);
        if (firstInvalid && firstInvalid.focus) firstInvalid.focus();
        showToast(t('form_check_data', 'Verifică datele și încearcă iar.'), 'error');
        return;
      }

      if (btn) btn.classList.add('is-loading');
      // WP build: the form's action points at a real REST lead endpoint -
      // POST it. (The static prototype has no /wp-json/ action and keeps the
      // old simulated delay so demos still behave.)
      const isRest = (form.action || '').includes('/wp-json/');
      let ok = true;
      let serverMsg = '';
      if (isRest) {
        try {
          const res = await fetch(form.action, {
            method: 'POST',
            credentials: 'same-origin',
            body: new FormData(form),
          });
          const data = await res.json().catch(() => null);
          ok = res.ok;
          if (data && data.message) serverMsg = data.message;
        } catch {
          ok = false;
        }
      } else {
        await new Promise((r) => setTimeout(r, 900));
      }
      if (btn) btn.classList.remove('is-loading');
      if (!ok) {
        showToast(serverMsg || t('error_retry', 'A apărut o eroare. Încearcă din nou.'), 'error');
        return;
      }
      form.reset();
      // Inline success block: a [data-role="lead-done"] sibling. Present on every
      // lead form now - hide the form and reveal the confirmation (same checkmark
      // + message style as the lead-cta forms). If a form ever lacks one, fall
      // back to the toast + closing the modal.
      const done = form.parentElement && form.parentElement.querySelector('[data-role="lead-done"]');
      if (done) {
        const doneMsg = done.querySelector('[data-role="lead-done-msg"]');
        if (doneMsg && serverMsg) doneMsg.textContent = serverMsg;
        form.hidden = true;
        done.hidden = false;
      } else {
        showToast(t('form_sent', 'Mesaj trimis. Te sunăm acum.'));
        // No inline confirmation available - close the modal if we're in one.
        form.dispatchEvent(new CustomEvent('modal:auto-close', { bubbles: true }));
      }
    });

    // Clear error state as user types
    on(form, 'input', (e) => {
      const field = e.target;
      if (field.classList && field.classList.contains('is-error') && field.checkValidity()) {
        field.classList.remove('is-error');
        const wrap = field.closest('.ap-field, .ap-form__consent');
        if (wrap) wrap.classList.remove('is-error');
      }
    });
  });
}
